import {Modal, Button, Typography} from "antd";
import "./PreSaleModal.scss";

const {Title} = Typography;

const PreSaleModal = ({showMessageModal, handleCancel, handlePopupClose}) => {
  return (
    <Modal
      title="Pre-Sale Confirmation"
      open={showMessageModal}
      onCancel={handleCancel}
      centered
      footer={null}
      width={400}
      className="pre-sale-modal"
    >
      <div className="modal-content">
        <p className="">
          <span>&#x2022;</span>{" "}
          <span>
            <span>This is a pre-sale purchase.  </span> Your account credentials will be issued to you on 31 July 2025.
          </span>
        </p>

        <div className="button-container">
          <Button
            type="primary"
            onClick={handlePopupClose}
            className="proceed-button"
          >
            Yes, Proceed
          </Button>
          <Button
            onClick={handleCancel}
            className="cancel-button"
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PreSaleModal;
